<template>
  <div class="exhibition_profile" ref="scrollProfile">
    <div class="container">
      <!--      <img-->
      <!--        class="ex_img1"-->
      <!--        :src="require('../../../assets/imgs/ex_img1.png')"-->
      <!--        alt=""-->
      <!--      />-->
      <div style="margin: 0 0 32px 156px"></div>
      <div class="flex flex_content_sb">
        <div class="profile_left">
          <!-- <titleConfig
            v-if="langSet == 'cn'"
            :title="'展会介绍'"
            :type="1"
          ></titleConfig> -->
          <!-- 25.10.17 文字替换 dxm -->
          <div class="profile_list">
            <div
              class="profile_item flex"
              v-for="(item, index) in list"
              :key="index"
            >
              <img :src="item.icon" alt="" />
              <div>
                <p class="num" v-if="item.num > 0">
                  <count-to
                    v-if="showNum"
                    :start-val="0"
                    :end-val="item.num"
                    :duration="2000"
                  ></count-to>
                  <span v-else>{{ item.num }}</span>
                  <span class="text">{{ index > 0 ? "+" : "m²" }}</span>
                </p>
                <p>{{ langSet == "cn" ? item.title : item.en_title }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="profile_right">
          <div class="sub_title">
            <template v-if="langSet == 'cn'">
              2026 中国国际口腔设备器材博览会
              <br />2026 China Dental Show
            </template>
            <template v-else> About 2026 China Dental Show </template>
          </div>
          <div class="profile_txt">
            {{
              langSet == "cn"
                ? "中国国际口腔设备器材博览会(China Dental Show)是由中华口腔医学会及国药励展联手打造的以汇集国内外口腔行业领先企业，涵盖口腔产品全产业链，以推广新产品、新技术，现场体验互动为核心，促进口腔生产经销企业提升品牌、促进贸易采购、交流合作的平台。"
                : "Held along with The Chinese Stomatological Association (CSA) Annual Congress, China Dental Show is a leading trade show which covers brand and product promotion, continuing education, trade negotiation and equipment procurement. We open the door in Shanghai to the largest amount of dentists from private and public hospitals as well as clinics and distributors in China, showcasing products and services from the entire value of chain of oral health."
            }}
          </div>
          <div class="flex flex_content_sb">
            <div class="video">
              <div
                class="video_btn flex flex_content_center flex_items_center"
                :class="langSet == 'cn' ? '' : 'video_enbtn'"
                @click="toLink"
              >
                {{ langSet == "cn" ? "观众预登记" : "Visitor Registration"
                }}<img
                  :src="require('../../../assets/imgs/icon_wright.png')"
                  alt=""
                />
              </div>
              <video
                id="video"
                :src="
                  langSet == 'cn' ? webData.home_video : webData.home_video_en
                "
                autoplay
                controls
                webkit-playsinline
                playsInline
                x5-playsinline
                t7-video-player-type="inline"
                controlsList="nodownload noremoteplayback disablePictureInPicture noplaybackrate"
              ></video>
            </div>
            <!-- <div class="profile_img flex flex_wrap flex_content_end">
              <img
                class="ex_dt"
                :src="require('../../../assets/imgs/ex_img2.png')"
                alt=""
              />
              <img
                class="ex_t"
                :src="require('../../../assets/imgs/ex_img3.png')"
                alt=""
              />
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import titleConfig from "@/components/title.vue";
import countTo from "vue-count-to";
export default {
  props: {
    webData: Object,
  },
  components: {
    //titleConfig,
    countTo,
  },
  data() {
    return {
      langSet: "",
      showNum: false,
      list: [
        {
          icon: require("../../../assets/imgs/p_icon1.png"),
          title: "展出面积",
          en_title: "exhibition area",
          num: "0",
        },
        {
          icon: require("../../../assets/imgs/p_icon2.png"),
          title: "参展企业",
          en_title: "exhibiting companies",
          num: "0",
        },
        {
          icon: require("../../../assets/imgs/p_icon3.png"),
          title: "专业观众",
          en_title: "visitors",
          num: "0",
        },
        {
          icon: require("../../../assets/imgs/p_icon4.png"),
          title: "会议活动",
          en_title: "conferences",
          num: "0",
        },
      ],
    };
  },
  mounted() {
    this.langSet = this.$language;
    this.list[0].num = this.webData.area;
    this.list[1].num = this.webData.company_num;
    this.list[2].num = this.webData.audience_num;
    this.list[3].num = this.webData.activity_num;
    // 25.6.11 滑动到指定元素，数字动画效果 dxm
    this.$nextTick(() => {
      window.addEventListener("scroll", this.scroll, true);
    });
  },
  methods: {
    scroll() {
      const el = this.$refs.scrollProfile;
      if (el) {
        var top = el.getBoundingClientRect().top; // 元素顶端到可见区域顶端的距离
        var se = document.documentElement.clientHeight; // 浏览器可见区域高度。
        if (!this.showNum && top < se) {
          this.showNum = true;
        }
      }
    },
    toLink() {
      if (this.langSet == "cn") {
        window.open(this.webData.registration_url, "_blank");
      } else {
        window.open(this.webData.registration_url_en, "_blank");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// 展会介绍
.exhibition_profile {
  // background: url("../../../assets/imgs/bg.png") no-repeat;
  // background-size: 100%;
  .container {
    padding: 110px 0 0px;
    background: url("../../../assets/imgs/ex_img4.png") no-repeat;
    background-position: right 32px;
    background-size: 198px;
  }
  .sub_title {
    color: #000;
    font-size: 34px;
    font-weight: bold;
    line-height: 44px;
    padding-bottom: 24px;
  }
  .ex_img1 {
    width: 168px;
    height: 168px;
    margin: 0 0 32px 156px;
  }
  .profile_left {
    flex: 1;
    margin-right: 40px;
    background: url("../../../assets/imgs/ex_img3.png") no-repeat;
    background-position: left bottom;
    background-size: 269px;
    margin-bottom: 20px;
    .profile_list {
      .profile_item {
        font-weight: 600;
        font-size: 21px;
        color: #004190;
        line-height: 29px;
        // margin-bottom: 60px;
        img {
          width: 40px;
          height: 40px;
          margin-top: 15px;
          margin-right: 10px;
        }
        .num {
          font-family: Arial, Arial;
          font-weight: 900;
          font-size: 50px;
          color: #e62344;
          line-height: 70px;
          .text {
            margin-left: -13px;
          }
        }
      }
    }
  }
  .profile_right {
    // flex: 1;
    width: 814px;
    font-size: 22px;
    color: #000;
    line-height: 36px;
    .profile_txt {
      margin-bottom: 30px;
    }
    .video {
      width: 100%;
      #video {
        width: 100%;
        min-height: 460px;
        display: block;
        margin-bottom: 30px;
      }
      .video_btn {
        width: 226px;
        height: 64px;
        font-size: 20px;
        color: #fff;
        background: url("../../../assets/imgs/button_bg.png") no-repeat;
        background-size: 100% 100%;
        margin-bottom: 28px;
        cursor: pointer;
        img {
          width: 28px;
          height: 28px;
          margin-left: 15px;
        }
      }
      .video_enbtn {
        width: 266px;
      }
    }
    .profile_img {
      padding-top: 38px;
      text-align: right;
      .ex_dt {
        width: 128px;
        height: 128px;
      }
      .ex_t {
        width: 220px;
        height: 340px;
        margin-top: 24px;
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .exhibition_profile {
    .ex_img1 {
      width: 138px;
      height: 138px;
      margin-bottom: 20px;
    }
    .profile_left {
      .sub_title {
        font-size: 24px;
      }
      .profile_list {
        .profile_item {
          .profile_item {
            font-size: 19px;
          }
          .num {
            font-size: 44px;
          }
        }
      }
    }
    .profile_right {
      font-size: 19px;
      position: relative;
      .video #video {
        width: 100%;
        height: auto;
      }
      .video .video_btn {
        width: 200px;
        height: 55px;
        font-size: 18px;
      }
      .video .video_enbtn {
        width: 240px;
      }
      .profile_img {
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: -1;
        width: 100px;
        .ex_t {
          margin-top: 10px;
        }
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .exhibition_profile {
    padding: 0;
    position: relative;
    .container {
      padding: 0;
      background: none;
    }
    .container > div {
      flex-wrap: wrap;
    }
    .ex_img1 {
      display: none;
    }
    .sub_title {
      font-size: 0.36rem;
      line-height: 0.35rem;
      margin-top: 0.08rem;
      padding-bottom: 0;
    }
    .profile_left {
      padding-top: 0;
      background-position: right center;
      background-size: 125px;
      margin-right: 0;
      .profile_list .profile_item {
        font-size: 0.31rem;
        line-height: 0.42rem;
        margin-top: 0.48rem;
        img {
          width: 0.58rem;
          height: 0.58rem;
          margin: 0.1rem 0.19rem 0 0;
        }
        .num {
          font-size: 0.54rem;
          line-height: 0.77rem;
          .text {
            margin-left: 0;
          }
        }
      }
    }
    .profile_right {
      font-size: 0.27rem;
      line-height: 0.42rem;
      .profile_txt {
        padding-top: 0.38rem;
        margin-bottom: 0.38rem;
      }
      .video {
        width: 100%;
        #video {
          min-height: 200px;
          margin-top: 0.29rem;
        }
        .video_btn {
          width: 4.12rem;
          height: 0.94rem;
          font-size: 0.29rem;
          line-height: 0.4rem;
          margin: 0 auto;
          img {
            width: 0.38rem;
            height: 0.38rem;
            margin-left: 0.17rem;
          }
        }
      }
    }
  }
  .exhibition_profile .profile_right .profile_img {
    position: absolute;
    top: -3.2rem;
    right: 0;
    .ex_dt {
      width: 2.08rem;
      height: 2.08rem;
    }
  }
  .exhibition_profile .profile_right .profile_img .ex_t {
    display: none;
  }
}
</style>